<div class="email-verification-container">
  <div class="email-verification-container-overlay"></div>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="email-verify email-verified text-center" *ngIf="isSuccessful">
          <div style="border-radius:200px; height:200px; width:200px; background: #F8FAF5; margin:0 auto;" class="email-verified">
            <i class="checkmark">✓</i>
          </div>
          <h1 class="email-verified">Success</h1>
          <p>Your email is verified.</p>
        </div>
        <div class="email-verify email-unverified text-center" *ngIf="!isSuccessful">
          <div style="border-radius:200px; height:200px; width:200px; background: #F8FAF5; margin:0 auto;" class="email-unverified">
            <i class="checkmark">x</i>
          </div>
          <h1 class="email-unverified">Unsuccessful</h1>
          <p>Your email was not verified. Message: </p>
          <p>{{errorMessage}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
